<template>
  <div class="container bg-white">
    <div class="m-xxl">
      <H2 font-family="Bitter" center>{{$t('configurator.thankYou')}}</H2>
      <p class="text-center">{{$t('configurator.thankYouText')}}</p>
    </div>
  </div>
</template>
<script>
import { H2 } from '@/components/common/styledHeading';

export default {
	components: {
		H2,
	},
};
</script>
